import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ClientPortalDevelopmentInfoModel, ICPLClientPortalDevelopmentsClient } from "./api/cplapi/CPLAPI";

export interface IClientPortalDevelopmentsService {
  getContacts(index: number | undefined, pageSize: number | undefined): Promise<ClientPortalDevelopmentInfoModel[]>;
}

@injectable()
export class ClientPortalDevelopmentsService implements IClientPortalDevelopmentsService {
  @inject(SERVICE_TYPES.CPLClientPortalDevelopmentsClient)
  cplClientPortalDevelopmentsClient!: ICPLClientPortalDevelopmentsClient;

  getContacts(index: number | undefined, pageSize: number | undefined): Promise<ClientPortalDevelopmentInfoModel[]> {
    return this.cplClientPortalDevelopmentsClient.getContacts(index, pageSize);
  }
}
